export const PlayOutlined = (props) => (
  <svg
    width='34'
    height='34'
    viewBox='0 0 34 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...props?.style }}
  >
    <rect x='0.5' y='0.5' width='33' height='33' rx='16.5' stroke='#14B8A6' />
    <circle cx='17.0003' cy='16.9998' r='13.3333' fill='#2DB0A9' />
    <path
      d='M21.6269 17.7071C22.0174 17.3166 22.0174 16.6834 21.6269 16.2929L16.0411 10.7071C15.4111 10.0771 14.334 10.5233 14.334 11.4142V22.5858C14.334 23.4767 15.4111 23.9229 16.0411 23.2929L21.6269 17.7071Z'
      fill='white'
    />
  </svg>
);
